module.exports = __webpack_public_path__ + "static/media/thomas.b62cd06c.jfif";